import { GemecoActions } from "@gemeco/Store/GemecoState";
import HeaderState from "@gemeco/Store/Pages/Header/HeaderState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<HeaderState, DispatchProp<GemecoActions>>;

export const UpdateState: HandlerType = props => {
    props.dispatch({
        type: "Pages/Header/UpdateHeaderState",
        parameter: props.parameter,
    });
};

export const chain = [UpdateState];

const updateHeaderState = createHandlerChainRunner(chain, "UpdateHeaderState");
export default updateHeaderState;
